// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27none%27 viewBox=%270 0 24 24%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M20.707 6.293a1 1 0 0 1 0 1.414l-8.586 8.586a3 3 0 0 1-4.243 0l-3.586-3.586a1 1 0 0 1 1.414-1.414l3.586 3.586a1 1 0 0 0 1.414 0l8.586-8.586a1 1 0 0 1 1.414 0z%27 fill=%27%2383bf6e%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k1sbNtA8ByHhTHxEUvE7.Rl05ERZaak05e_bR9Be2 .M2sxnWkYT6GC34T6nUna {
  padding-left: 48px;
}
.k1sbNtA8ByHhTHxEUvE7.xAFEaUL8dRd8ik60JqZ9 .M2sxnWkYT6GC34T6nUna {
  padding-left: 58px;
  background: none;
  border-color: #EFEFEF;
}
.k1sbNtA8ByHhTHxEUvE7.xAFEaUL8dRd8ik60JqZ9 .M2sxnWkYT6GC34T6nUna:focus {
  border-color: #9A9FA5;
}
.dark-mode .k1sbNtA8ByHhTHxEUvE7.xAFEaUL8dRd8ik60JqZ9 .M2sxnWkYT6GC34T6nUna {
  border-color: #272B30;
}
.dark-mode .k1sbNtA8ByHhTHxEUvE7.xAFEaUL8dRd8ik60JqZ9 .M2sxnWkYT6GC34T6nUna:focus {
  border-color: #33383F;
}

.k1sbNtA8ByHhTHxEUvE7.diqNqeMxlT7NGMSR55Cp .M2sxnWkYT6GC34T6nUna {
  padding-right: 48px;
}
.k1sbNtA8ByHhTHxEUvE7.f_Z2C0xCPtCejN6jmRYW {
  font-size: 12px;
}
.k1sbNtA8ByHhTHxEUvE7.f_Z2C0xCPtCejN6jmRYW .aNMLyL6hjU2r04051lgm svg {
  fill: #FF6A55;
}
.k1sbNtA8ByHhTHxEUvE7.f_Z2C0xCPtCejN6jmRYW .M2sxnWkYT6GC34T6nUna {
  padding-right: 48px;
  background: rgba(255, 188, 153, 0.25);
  border-color: transparent;
  color: #FF6A55;
}
.dark-mode .k1sbNtA8ByHhTHxEUvE7.f_Z2C0xCPtCejN6jmRYW .M2sxnWkYT6GC34T6nUna:focus {
  border-color: #FF6A55;
  color: #FF6A55;
}

.k1sbNtA8ByHhTHxEUvE7.f_Z2C0xCPtCejN6jmRYW .M2sxnWkYT6GC34T6nUna::placeholder {
  color: #FF6A55;
}
.k1sbNtA8ByHhTHxEUvE7.cdv2lAlRaJtXfEMAozX3 .Hhh5lkpsNixK5Sc95Mgt:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 48px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%/24px auto;
}
.k1sbNtA8ByHhTHxEUvE7.cdv2lAlRaJtXfEMAozX3 .M2sxnWkYT6GC34T6nUna {
  padding-right: 48px;
  background: #FFFFFF;
  border-color: #9A9FA5;
}
.dark-mode .k1sbNtA8ByHhTHxEUvE7.cdv2lAlRaJtXfEMAozX3 .M2sxnWkYT6GC34T6nUna {
  background: #111315;
}

.RGrOFA0Lyjz6B7KrnGLm {
  margin-bottom: 14px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  color: #33383F;
}
.dark-mode .RGrOFA0Lyjz6B7KrnGLm {
  color: #EFEFEF;
}

.BdmDYKofRyhc4ynaKBTA {
  position: relative;
  top: -1px;
}
.BdmDYKofRyhc4ynaKBTA svg {
  fill: #9A9FA5;
}

.Hhh5lkpsNixK5Sc95Mgt {
  position: relative;
}

.M2sxnWkYT6GC34T6nUna {
  width: 100%;
  height: 48px;
  padding: 0 10px;
  border-radius: 12px;
  border: 2px solid transparent;
  background: #F4F4F4;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #1A1D1F;
  transition: all 0.2s;
}
.dark-mode .M2sxnWkYT6GC34T6nUna {
  border-color: #272B30;
  background: #272B30;
  color: #FCFCFC;
}

.M2sxnWkYT6GC34T6nUna::placeholder {
  color: #6F767E;
}
.dark-mode .M2sxnWkYT6GC34T6nUna::placeholder {
  color: #9A9FA5;
}

.M2sxnWkYT6GC34T6nUna:focus {
  border-color: #9A9FA5;
  background: #FFFFFF;
}
.dark-mode .M2sxnWkYT6GC34T6nUna:focus {
  border-color: #33383F;
  background: #111315;
}

.aNMLyL6hjU2r04051lgm,
.S0VMDcOUjsaV07QKW5A7 {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
}

.aNMLyL6hjU2r04051lgm {
  left: 0;
  pointer-events: none;
}
.aNMLyL6hjU2r04051lgm svg {
  fill: #6F767E;
}

.S0VMDcOUjsaV07QKW5A7 {
  right: 0;
}
.S0VMDcOUjsaV07QKW5A7 svg {
  fill: #6F767E;
  transition: fill 0.2s;
}
.S0VMDcOUjsaV07QKW5A7:hover svg {
  fill: #2A85FF;
}

.FtyIDk7CgW4NX9wZ7f1E {
  position: absolute;
  top: 2px;
  left: 2px;
  bottom: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 46px;
  padding-top: 1px;
  border-radius: 10px 0 0 10px;
  background: #F4F4F4;
  color: #1A1D1F;
}
.dark-mode .FtyIDk7CgW4NX9wZ7f1E {
  background: #272B30;
  color: #6F767E;
}

.cv1s6gaQHj1jrFfFlQDt {
  height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/components/TextInput/TextInput.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAIQ;EACI,kBAAA;AAHZ;AAKQ;EACI,kBAAA;EACA,gBAAA;EACA,qBCiCP;ADpCL;AAIY;EACI,qBCsCN;ADxCV;ACkLa;ED9KG,qBCgCX;ADjCL;AAEgB;EACI,qBC6Bf;AD7BL;;AAEQ;EACI,mBAAA;AACZ;AAAI;EACI,eAAA;AAER;AAAY;EACI,aCQX;ADNL;AADQ;EACI,mBAAA;EACA,qCAAA;EACA,yBAAA;EACA,cCGP;ADAL;AADgB;EACI,qBAAA;EACA,cCDf;ADIL;;AAFY;EACI,cCHX;ADQL;AAFY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,+EAAA;AAIhB;AAHQ;EACI,mBAAA;EACA,mBCRR;EDSQ,qBCCF;ADIV;ACsIa;EDzIG,mBCHX;ADSL;;AAJA;EACI,mBAAA;ECkCA,eAAA;EACA,gBAAA;EACA,yBAAA;EDlCA,cCXC;ADoBL;AC2Ha;EDlIL,cCfH;ADyBL;;AARA;EACI,kBAAA;EACA,SAAA;AAWJ;AAVI;EACI,aCdE;AD0BV;;AAVA;EACI,kBAAA;AAaJ;;AAXA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBCjCC;EAfD,gCAAA;EAmDA,eAAA;EACA,gBAAA;EACA,gBAAA;EDFA,cC/BC;EDgCD,oBAAA;AAgBJ;AC6Fa;ED3GL,qBCnCH;EDoCG,mBCpCH;EDqCG,cC1CH;AD2DL;;AC0EI;EDzFI,cCzCH;AD4DL;ACoFa;EDrGD,cCrCF;ADyDV;;AAnBI;EACI,qBCvCE;EDwCF,mBClDJ;ADwEJ;AC4Ea;EDhGD,qBC/CP;EDgDO,mBC7CP;ADoEL;;AArBA;;EAEI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAwBJ;;AAtBA;EACI,OAAA;EACA,oBAAA;AAyBJ;AAxBI;EACI,aCjEH;AD2FL;;AAxBA;EACI,QAAA;AA2BJ;AA1BI;EACI,aCtEH;EDuEG,qBAAA;AA4BR;AA1BQ;EACI,aCxFP;ADoHL;;AA1BA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBCzFC;ED0FD,cCrFC;ADkHL;AC2Ba;EDtDL,mBCxFH;EDyFG,cC3FH;ADyHL;;AA3BA;EACI,aAAA;AA8BJ","sourcesContent":["@import ../../styles/helpers\n\n.field\n    &.fieldIcon\n        .input\n            padding-left: 48px\n    &.fieldCurrency\n        .input\n            padding-left: 58px\n            background: none\n            border-color: $n3\n            &:focus\n                border-color: $shades1\n            +dark\n                border-color: $n6\n                &:focus\n                    border-color: $n5\n    &.fieldCopy\n        .input\n            padding-right: 48px\n    &.error\n        font-size: 12px\n        .icon\n            svg\n                fill: $p3\n        .input\n            padding-right: 48px\n            background: rgba($s1, .25)\n            border-color: transparent\n            color: $p3\n            +dark\n                &:focus\n                    border-color: $p3\n                    color: $p3\n            &::placeholder\n                color: $p3\n    &.success\n        .wrap\n            &:after\n                content: \"\"\n                position: absolute\n                top: 0\n                right: 0\n                bottom: 0\n                width: 48px\n                background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill-rule='evenodd' d='M20.707 6.293a1 1 0 0 1 0 1.414l-8.586 8.586a3 3 0 0 1-4.243 0l-3.586-3.586a1 1 0 0 1 1.414-1.414l3.586 3.586a1 1 0 0 0 1.414 0l8.586-8.586a1 1 0 0 1 1.414 0z' fill='%2383bf6e'/%3E%3C/svg%3E\") no-repeat 50% 50% / 24px auto\n        .input\n            padding-right: 48px\n            background: $n\n            border-color: $shades1\n            +dark\n                background: $n8\n\n.label\n    margin-bottom: 14px\n    +base2\n    color: $n5\n    +dark\n        color: $n3\n\n.tooltip\n    position: relative\n    top: -1px\n    svg\n        fill: $shades1\n\n.wrap\n    position: relative\n\n.input\n    width: 100%\n    height: 48px\n    padding: 0 10px\n    border-radius: 12px\n    border: 2px solid transparent\n    background: $n2\n    +inter\n    +base1-s\n    color: $n7\n    transition: all .2s\n    +dark\n        border-color: $n6\n        background: $n6\n        color: $n1\n    +placeholder\n        color: $n4\n        +dark\n            color: $shades1\n    &:focus\n        border-color: $shades1\n        background: $n\n        +dark\n            border-color: $n5\n            background: $n8\n\n.icon,\n.copy\n    position: absolute\n    top: 0\n    bottom: 0\n    display: flex\n    justify-content: center\n    align-items: center\n    width: 48px\n\n.icon\n    left: 0\n    pointer-events: none\n    svg\n        fill: $n4\n\n.copy\n    right: 0\n    svg\n        fill: $n4\n        transition: fill .2s\n    &:hover\n        svg\n            fill: $p1\n\n.currency\n    position: absolute\n    top: 2px\n    left: 2px\n    bottom: 2px\n    display: flex\n    justify-content: center\n    align-items: center\n    width: 46px\n    padding-top: 1px\n    border-radius: 10px 0 0 10px\n    background: $n2\n    color: $n7\n    +dark\n        background: $n6\n        color: $n4\n\n\n.textarea\n    height: 100px","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field": `k1sbNtA8ByHhTHxEUvE7`,
	"fieldIcon": `Rl05ERZaak05e_bR9Be2`,
	"input": `M2sxnWkYT6GC34T6nUna`,
	"fieldCurrency": `xAFEaUL8dRd8ik60JqZ9`,
	"fieldCopy": `diqNqeMxlT7NGMSR55Cp`,
	"error": `f_Z2C0xCPtCejN6jmRYW`,
	"icon": `aNMLyL6hjU2r04051lgm`,
	"success": `cdv2lAlRaJtXfEMAozX3`,
	"wrap": `Hhh5lkpsNixK5Sc95Mgt`,
	"label": `RGrOFA0Lyjz6B7KrnGLm`,
	"tooltip": `BdmDYKofRyhc4ynaKBTA`,
	"copy": `S0VMDcOUjsaV07QKW5A7`,
	"currency": `FtyIDk7CgW4NX9wZ7f1E`,
	"textarea": `cv1s6gaQHj1jrFfFlQDt`
};
export default ___CSS_LOADER_EXPORT___;
